































import { Component, Prop, Vue } from 'vue-property-decorator';
import Teacher from '@/services/Teacher';
import { Teacher as ITeacher } from '@/models/Teachers';
import { IModule } from '@/models/Modules';
import Modules from '@/services/Modules';

@Component
export default class ModuleModal extends Vue {
  @Prop({ default: null }) data!: IModule | null;
  public module: IModule | null = null;

  public emptyModule: IModule = {
    id: null,
    name: '',
    url: '',
    thumbnail: '',
    locked: false,
  };

  mounted() {
    this.module = this.emptyModule;
    if (this.data) {
      this.module = this.data;
    }

    this.$nextTick(() => {
      (this.$refs.first as HTMLInputElement).focus();
    });
  }

  get formDisabled() {
    return !this.module || !this.module.name || !this.module.url || !this.module.thumbnail;
  }

  async addModule() {
    if (!this.module || !this.module.name || !this.module.url || !this.module.thumbnail) {
      return;
    }

    if (this.module.id) {
      // Edit existing module
      await Modules.editModule(this.module);
    } else {
      // Create new module
      const teacherId = this.$route.params.id;
      const teacher = (await Teacher.getTeacherById(teacherId)) as ITeacher;
      teacher.id = teacherId;
      await Modules.createModule(this.module, teacher);
    }

    this.closeModal();
  }

  closeModal() {
    this.$parent.$emit('close-modal');
  }
}
